export default __webpack_public_path__ + "static/media/check-in-banner-ms.dbd0354a.webp";